export default __webpack_public_path__ + "static/media/sandal5.0e699ecc.jpeg";